import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import { FormsModule } from '@angular/forms';

@Component({
  selector: 'table-check-row',
  template: `
    <td>
      <input
        type="checkbox"
        #select="ngModel"
        ngModel
        (change)="tableCheckRow(select.value, rowData)"
        [checked]="selected.includes(rowData)"
      />
    </td>
  `,
  styles: [
    `
      input[type='checkbox'] {
        /* Double-sized Checkboxes */
        -ms-transform: scale(1.3); /* IE */
        -moz-transform: scale(1.3); /* FF */
        -webkit-transform: scale(1.3); /* Safari and Chrome */
        -o-transform: scale(1.3); /* Opera */
        transform: scale(1.3);
      }
    `,
  ],
  imports: [FormsModule],
  changeDetection: ChangeDetectionStrategy.Eager,
})
export class TableCheckRowComponent {
  // eslint-disable-next-line @typescript-eslint/no-unsafe-function-type
  @Input() tableCheckRow: Function;
  @Input() selected: any[];
  @Input() rowData: any;
}
